import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { ReactTemplateSymbol, ESMLoaderFactorySymbol, ESMLoadRegistrarSymbol } from './symbols'
import { ReactTemplateFactory } from './reactTemplateFactory'
import { ESMLoaderFactoryFactory } from './esmLoaderFactory'
import { ESMLoadRegistrarFactory } from './esmLoadRegistrar'

export const site: ContainerModuleLoader = (bind) => {
	bind(ReactTemplateSymbol).to(ReactTemplateFactory)
	bind(ESMLoadRegistrarSymbol).to(ESMLoadRegistrarFactory)
	bind(ESMLoaderFactorySymbol).to(ESMLoaderFactoryFactory)
}

export const editor: ContainerModuleLoader = site

// Export symbols and types for use by other features
export { ReactTemplateSymbol, ESMLoaderFactorySymbol, ESMLoadRegistrarSymbol } from './symbols'
export type { ReactTemplate, ESMLoaderFactory, ESMLoadRegistrar } from './types'
